import React, { useEffect, useState } from "react";

const DailyPerformanceCircle = ({
  redValue = 45,
  greenValue = 80,
  dateLabel = "Hier",
}) => {
  const [redProgress, setRedProgress] = useState(0);
  const [greenProgress, setGreenProgress] = useState(0);

  useEffect(() => {
    const timeout1 = setTimeout(() => setRedProgress(redValue), 300);
    const timeout2 = setTimeout(() => setGreenProgress(greenValue), 600);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
  }, [redValue, greenValue]);

  const size = 140;
  const strokeWidth = 6;

  // Cercles séparés
  const radiusGreen = (size - strokeWidth) / 2; // Cercle extérieur (vert)
  const radiusRed = radiusGreen - 12; // Cercle intérieur (rouge)

  const getCircumference = (r) => 2 * Math.PI * r;
  const getOffset = (value, r) =>
    getCircumference(r) - (value / 100) * getCircumference(r);

  return (
    <div className="bg-white p-2 rounded-xl shadow-md w-full m-auto">
      <div className="text-center font-semibold mb-4 mt-1">
        {dateLabel} <span>▼</span>
      </div>

      <svg width={size} height={size} className="mx-auto rotate-[-90deg]">
        {/* Cercles de fond */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radiusGreen}
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radiusRed}
          stroke="#fcf7fc"
          strokeWidth={strokeWidth}
          fill="none"
        />

        {/* Cercle vert (extérieur) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radiusGreen}
          stroke="#10b981"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={getCircumference(radiusGreen)}
          strokeDashoffset={getOffset(greenProgress, radiusGreen)}
          style={{
            transition: "stroke-dashoffset 1s ease",
          }}
        />

        {/* Cercle rouge (intérieur) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radiusRed}
          stroke="#f97316"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={getCircumference(radiusRed)}
          strokeDashoffset={getOffset(redProgress, radiusRed)}
          style={{ transition: "stroke-dashoffset 1s ease" }}
        />
      </svg>

      {/* Textes au centre */}
      <div className="text-center mt-[-70px] rotate-[0deg]">
        <div className="text-2xl font-bold text-orange-500 relative bottom-4">
          {redProgress}%
        </div>
        <div className="text-sm text-green-600">{greenProgress}%</div>
      </div>

      {/* Légende */}
      <div className="flex justify-center gap-5 mt-4 text-sm">
        <div className="flex items-center gap-0.5 text-orange-500 mt-3">
          <span className="w-1 h-2.5 bg-orange-500 block rounded" />
          Faible
        </div>
        <div className="flex items-center gap-0.5 text-green-600 mt-3">
          <span className="w-1 h-2.5 bg-green-600 block rounded" />
          Très bien
        </div>
      </div>
    </div>
  );
};

export default DailyPerformanceCircle;
